import { EnigmeAdminModel } from "../models/enigmeAdmin.model";
import { TranslateAdminModel } from "../models/translateAdmin.model";

/**
 * The CTF admin list endpoint (GetCtfAdminAction) returns `name` as a
 * plain string, even though EnigmeAdminModel types it as the per-language
 * array (TranslateAdminModel[]) used by the edit/create forms. Handle
 * both shapes defensively at runtime instead of trusting the static type.
 */
export function getEnigmeName(
  enigme: EnigmeAdminModel,
  currentLang: string,
): string {
  const name = enigme.name as unknown as TranslateAdminModel[] | string;
  if (typeof name === "string") {
    return name;
  }
  return (
    name.find((lang) => lang.language === currentLang)?.label ??
    name[0]?.label ??
    ""
  );
}
